(function () {
  'use strict';

  if (window.__nestMrcCartJqueryFilter20260708) return;
  window.__nestMrcCartJqueryFilter20260708 = 'v1-filter-cart-json-before-drawer-render';

  var feeVariantId = 39273096544337;
  var feeProductId = 6543483142225;
  var retryCount = 0;
  var maxRetryCount = 80;

  function textOf(item) {
    return [
      item && item.product_title,
      item && item.title,
      item && item.handle,
      item && item.url,
      item && item.product_type,
      item && item.vendor
    ].join(' ').toLowerCase();
  }

  function propsOf(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function isMrcFee(item) {
    var props = propsOf(item);
    var text = textOf(item);
    return Number(item && item.variant_id) === feeVariantId ||
      Number(item && item.product_id) === feeProductId ||
      String(props.type || '').toLowerCase() === 'fee' ||
      text.indexOf('mrc recycling fee') > -1 ||
      text.indexOf('mattress recycling fee') > -1;
  }

  function mrcFeeQty(cart) {
    return (cart && cart.items || []).reduce(function (sum, item) {
      return sum + (isMrcFee(item) ? Number(item.quantity || 0) : 0);
    }, 0);
  }

  function mrcFeeCents(cart) {
    return (cart && cart.items || []).reduce(function (sum, item) {
      return sum + (isMrcFee(item) ? Number(item.final_line_price || 0) : 0);
    }, 0);
  }

  function isCartJsonUrl(url) {
    if (typeof url !== 'string' || /mrc_raw=1/i.test(url)) return false;
    return /\/cart(?:\.js|\/add\.js|\/change\.js|\/update\.js)(?:\?|$)/.test(url);
  }

  function transformCartPayload(payload) {
    if (!payload || !Array.isArray(payload.items)) return payload;
    var feeQty = mrcFeeQty(payload);
    var feeCents = mrcFeeCents(payload);
    if (feeQty <= 0 && feeCents <= 0) return payload;

    var clone = Object.assign({}, payload);
    clone.items = payload.items.filter(function (item) { return !isMrcFee(item); });
    if (typeof payload.item_count === 'number') clone.item_count = Math.max(0, payload.item_count - feeQty);
    if (typeof payload.item_count === 'string') clone.item_count = String(Math.max(0, Number(payload.item_count || 0) - feeQty));
    clone.__nest_mrc_fee_quantity = feeQty;
    clone.__nest_mrc_fee_cents = feeCents;
    return clone;
  }

  function parseAndTransform(data) {
    if (typeof data !== 'string') return data;
    try {
      return JSON.stringify(transformCartPayload(JSON.parse(data)));
    } catch (error) {
      return data;
    }
  }

  function installJqueryFilter() {
    var $ = window.jQuery || window.$;
    if (!$ || !$.ajax || $.ajax.__nestMrcCartJqueryFilter20260708) {
      retryCount += 1;
      if (retryCount < maxRetryCount) window.setTimeout(installJqueryFilter, 100);
      return;
    }

    var originalAjax = $.ajax;

    $.ajax = function () {
      var first = arguments[0];
      var second = arguments[1];
      var settings = typeof first === 'object' ? Object.assign({}, first) : Object.assign({}, second || {}, { url: first });
      var url = typeof settings.url === 'string' ? settings.url : '';

      if (!isCartJsonUrl(url)) {
        return originalAjax.apply(this, arguments);
      }

      var originalDataFilter = settings.dataFilter;
      settings.dataFilter = function (data, type) {
        var filtered = typeof originalDataFilter === 'function' ? originalDataFilter.call(this, data, type) : data;
        return parseAndTransform(filtered);
      };

      return originalAjax.call(this, settings);
    };

    $.ajax.__nestMrcCartJqueryFilter20260708 = true;
  }

  installJqueryFilter();
})();
